import React from 'react';

import { MultiSelect, MultiSelectProps } from '@mantine/core';
import { Invoice } from 'types';

const InvoiceStatusMultiSelect = ({ ...multiSelectProps }: Omit<MultiSelectProps, 'data'>): JSX.Element => {
  const options: { label: string; value: Invoice['status'] }[] = [
    { label: 'Upcoming', value: 'UPCOMING' },
    { label: 'Paid', value: 'PAID' },
    { label: 'Partially Refunded', value: 'PARTIALLY REFUNDED' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Past Due', value: 'PAST DUE' },
    { label: 'Payment Failed', value: 'PAYMENT FAILED' },
    { label: 'Failed Past Due', value: 'FAILED PAST DUE' },
    { label: 'Refunded', value: 'REFUNDED' },
    { label: 'Refund Pending', value: 'REFUND PENDING' },
    { label: 'Void', value: 'VOID' },
  ];

  return <MultiSelect data={options} {...multiSelectProps} />;
};

export default InvoiceStatusMultiSelect;
